module.exports = __webpack_public_path__ + "fonts/GT-Eesti-Display-Regular.97f3e2d.otf";